export default __webpack_public_path__ + "static/media/avatarofdeath.e4a946b4.png";